import { useLoading } from '../context/LoadingContext';

function AppContent({ children }) {
    const { isLoading } = useLoading();

    // Use CSS to hide content instead of not rendering it
    // This prevents initScripts from crashing
    return (
        <div style={{ display: isLoading ? 'none' : 'block' }}>
            {children}
        </div>
    );
}

export default AppContent;
